import React, { PureComponent } from "react";
import PageLink from "../../../components/Page/PageLink";
import Footer from "../../../components/Footer/Footer";
import InterfaceProperties from "../../../components/Interface/InterfaceProperties";
import InterfaceCompatibility from "../../../components/Interface/InterfaceCompatibility";

class Component_record_checkbox extends PureComponent {
  render() {
    return (
      <div className="row" id="component_record_checkbox">
        <div className="col-md-6">
          <div className="contentLight">
            <section>
              <h2>Record Checkbox</h2>
              <p>
                Checkboxes are simple on-off controls. Checkboxes always use the
                data type of bool to represent true or false.
              </p>
              <InterfaceCompatibility
                dashboard={false}
                record={true}
                report={false}
                search={false}
              />
              <InterfaceProperties
                type={"record_checkbox"}
                name={"checkbox"}
                ataNameDefault={
                  '"bool_my_field" or object_my_obj.bool_my_field"'
                }
                autoFill={"true or false"}
                padding={true}
                hide={true}
                order={true}
                button={false}
                tabIndex={true}
                readOnly={true}
                displayName={true}
                onChangeEval={true}
                properties={[
                  {
                    property: "label_color",
                    description: "Set the color of the text.",
                    defaults:
                      '"#F44336", "#388E3C" default is "RGBA(0, 0, 0, 0.87)"'
                  },
                  {
                    property: "label_bold",
                    description: "Sets text to bold.",
                    defaults: "true, false default is false"
                  }
                ]}
              />
              <Footer
                section={this.props.section}
                article={this.props.article}
                routeParams={this.props.routeParams}
              />
            </section>
          </div>
        </div>
        <div className="col-md-6 darkCol">
          <div className="contentDark">
            <section>
              <h2>Record Checkbox Example</h2>
            </section>
            <section>
              <h3>Example 1: Simple Texbox</h3>
              <div className="darkCode">
                <div>&#123;</div>
                <strong>
                  <div className="i1">
                    <span className="jsonG">"type"</span>:{" "}
                    <span className="jsonY">"record_checkbox"</span>,
                  </div>
                </strong>
                <div className="i1">
                  <span className="jsonG">"data_name"</span>:{" "}
                  <span className="jsonY">"bool_my_field"</span>,
                </div>
                <div className="i1">
                  <span className="jsonG">"display_name"</span>:{" "}
                  <span className="jsonY">"My Field"</span>,
                </div>
                <div className="i1">
                  <span className="jsonG">"order"</span>:{" "}
                  <span className="jsonP">1</span>
                </div>
                <div>&#125;</div>
              </div>
            </section>
          </div>
        </div>
      </div>
    );
  }
}

export default Component_record_checkbox;



// WEBPACK FOOTER //
// ./src/components/knowlege/interface/Component_record_checkbox.js